@if (results && results.data?.upa?.length && results.data?.upa?.length > 1) {
  <ngb-carousel [pauseOnHover]="true" [interval]="2000">
    @for (upa of results?.data?.upa; track upa) {
      @if (upa.photos?.length) {
        <ng-template ngbSlide>
          <div class="upa_image">
            <img [src]="upa.photos[0].largeUrl" alt="" />
          </div>
          <div class="upa_header">
            {{ upa.headline }}
          </div>
          <div class="upa_desc">
            {{ upa.description }}
          </div>
        </ng-template>
      }
    }
  </ngb-carousel>
}
@if (
  results &&
  results.data?.upa?.length &&
  results.data?.upa?.length === 1 &&
  results.data?.upa[0].photos.length
) {
  <div class="upa_image">
    <img [src]="results.data?.upa[0].photos[0].largeUrl" alt="" />
  </div>
  <div class="upa_header">
    {{ results.data?.upa[0].headline }}
  </div>
  <div class="upa_desc single_upa_desc">
    {{ results.data?.upa[0].description }}
  </div>
}
@if (!results || !results.data?.upa?.length) {
  <div class="error-message" i18n="@@modalRoutehappyUPAsUnavailable">
    Product info unavailable for this flight.
  </div>
}
